var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 8.625V7.17969C18 6.98438 17.9219 6.82813 17.8047 6.71094L16.1641 5.07031C16.0469 4.95313 15.8906 4.875 15.7344 4.875H8.625C8.27344 4.875 8 5.14844 8 5.5V8.625H6.125V5.5C6.125 4.13281 7.25781 3 8.625 3H15.7344C16.3984 3 17.0234 3.27344 17.4922 3.74219L19.1328 5.38281C19.6016 5.85156 19.875 6.51563 19.875 7.17969V8.625H18ZM17.375 17.375H8.625V21.125H17.375V17.375ZM8 15.5H18C18.7031 15.5 19.25 16.0469 19.25 16.75V17.375H21.125V13C21.125 12.6484 20.8516 12.375 20.5 12.375H5.5C5.14844 12.375 4.875 12.6484 4.875 13V17.375H6.75V16.75C6.75 16.0469 7.29688 15.5 8 15.5ZM19.25 19.25V21.75C19.25 22.4531 18.7031 23 18 23H8C7.29688 23 6.75 22.4531 6.75 21.75V19.25H4.25C3.54688 19.25 3 18.7031 3 18V13C3 11.6328 4.13281 10.5 5.5 10.5H20.5C21.8672 10.5 23 11.6328 23 13V18C23 18.7031 22.4531 19.25 21.75 19.25H19.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.caeffd4a98674849577fd4a99c9805bf.svg";
export { ForwardRef as ReactComponent };